import EventTreeMxGraph from 'hcl-web-editor/app/mxGraph/HCLTreeMxGraph/EventTreeMxGraph';

const EVENT_EDITOR_IDS_VISIBLE = 'eventEditorNodeIdsVisible';

class PhoenixEditorEventTreeMxGraph extends EventTreeMxGraph {
  public getIDsVisible(): boolean {
    const provider = this.getPreferencesProvider();
    if (provider) {
      const pref = provider.getPreference(EVENT_EDITOR_IDS_VISIBLE);
      return pref !== null && pref !== undefined ? Boolean(pref) : false;
    }
    return false;
  }

  public setIDsVisible(visible: boolean): void {
    const provider = this.getPreferencesProvider();
    if (provider) {
      provider.setPreference(EVENT_EDITOR_IDS_VISIBLE, visible);
    }
    this.refresh(null);
  }
}

export default PhoenixEditorEventTreeMxGraph;
